import { useDarkMode } from '../context/DarkModeContext';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  hideTextOnMobile?: boolean;
}

export function Logo({ size = 'md', hideTextOnMobile = false }: LogoProps) {
  const { darkMode } = useDarkMode();

  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-3xl',
  }[size];

  return (
    <span className={`${sizeClasses} font-bold tracking-tight ${hideTextOnMobile ? 'hidden md:inline' : ''}`}>
      <span className={darkMode ? 'text-slate-100' : 'text-slate-900'}>
        Berater
      </span>
      {' '}
      <span className="text-[#c5524d]">Digital</span>
    </span>
  );
}
